export default "__VITE_ASSET__IJzIx4iH__"